import React, { useState, useEffect } from 'react';
import ProductCard from '../components/ProductCard';
import { useStore } from '../context/StoreContext';
import { useFilter } from '../context/FilterContext';

const Home = () => {
    const { products, loading, error } = useStore();
    const { searchTerm, selectedCategory } = useFilter();
    const [filteredProducts, setFilteredProducts] = useState([]);

    useEffect(() => {
        let results = products;

        // Apply category filter
        if (selectedCategory && selectedCategory !== 'All') {
            results = results.filter(p => p.category === selectedCategory);
        }

        // Apply search term filter
        if (searchTerm) {
            results = results.filter(p => {
                const nameMatch = p.name && typeof p.name === 'string' && p.name.toLowerCase().includes(searchTerm.toLowerCase());
                const descriptionMatch = p.description && typeof p.description === 'string' && p.description.toLowerCase().includes(searchTerm.toLowerCase());
                return nameMatch || descriptionMatch;
            });
        }
        
        setFilteredProducts(results);

    }, [searchTerm, selectedCategory, products]);

    if (loading) {
        return <div className="text-center py-16 text-blue-600 font-semibold text-xl">Loading products...</div>;
    }

    if (error) {
        return <div className="text-center py-16 text-red-600 font-semibold text-xl">Error: {error}</div>;
    }

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {/* Only show the hero banner if no filters are active */}
            {!searchTerm && selectedCategory === 'All' && (
                 <div className="bg-gradient-to-r from-blue-700 to-indigo-900 text-white rounded-lg shadow-2xl mb-12 p-12 text-center">
                    <h1 className="text-5xl font-extrabold mb-4">Welcome to LumioTec</h1>
                    <p className="text-xl text-blue-200 mb-8 max-w-2xl mx-auto">Your one-stop shop for the latest and greatest in electronics.</p>
                    <a href="#products" className="bg-yellow-400 text-blue-900 font-bold py-3 px-8 rounded-full hover:bg-yellow-300 transition-all duration-300 transform hover:scale-110 shadow-lg">
                        Shop Now
                    </a>
                </div>
            )}

            <div id="products">
                <h2 className="text-4xl font-bold text-gray-800 mb-8 border-l-4 border-yellow-400 pl-4">
                    {selectedCategory === 'All' ? 'Featured Products' : selectedCategory}
                </h2>
                
                {filteredProducts.length > 0 ? (
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8"> 
                        {filteredProducts.map(product => (
                            <ProductCard key={product.id} product={product} /> 
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-16 text-gray-500 font-semibold text-xl">
                        No products found matching your criteria.
                    </div>
                )}
            </div>
        </div>
    );
};

export default Home;